import React from "react";
import styled, { css } from "styled-components";

const ListCardInfo = props => {
  // const { BodyInfoHeader, BodyInfoBottom } = props;
  return (
    <Container status={props.status} borderColor={props.borderColor}>
      <Body>
        <BodyInfo>
          <BodyInfoHeader onClick={props.bodyInfoBodyAction}>
            {props.bodyInfoHeader}
          </BodyInfoHeader>
          <BodyInfoBody onClick={props.bodyInfoBodyAction}>
            {props.bodyInfoBody.map((item, i) => (
              <BodyInfoBodyContent key={"BodyInfoBodyContent" + i}>
                {item.left} {item.right}
              </BodyInfoBodyContent>
            ))}
          </BodyInfoBody>
          {props.bodyInfoBottom != "" && (
            <BodyInfoBottom>{props.bodyInfoBottom}</BodyInfoBottom>
          )}
        </BodyInfo>

        {props.bodyIcon && (
          <BodyIcon thumnail={props.bodyIcon[0].thumnail}>
            {props.bodyIcon.map((item, i) => (
              <BodyIconContents
                key={"BodyIconContents" + i}
                onClick={item.action}
                thumnail={item.thumnail}>
                {item.icon != "" ? <img src={item.icon} /> : ""}
              </BodyIconContents>
            ))}
          </BodyIcon>
        )}
      </Body>

      {props.bottom && props.bottom.length > 0 && (
        <Bottom>
          {props.bottom.map(
            (item, idx) =>
              item != false && (
                <BottomButton
                  onClick={item.action}
                  idx={idx}
                  key={"bottomBtnIdx" + idx}>
                  <BottomButtonText>{item.text}</BottomButtonText>
                </BottomButton>
              )
          )}
        </Bottom>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  border-radius: 10px;
  border: 1px solid
    ${props => (props.status === "default" ? "#eee" : "#6B65DE")};
  background: #fff;

  ${props =>
    props.borderColor
      ? css`
          border: 1px solid ${props.borderColor};
        `
      : css`
          border: 1px solid
            ${props => (props.status === "default" ? "#eee" : "#6B65DE")};
        `}
`;

const Body = styled.div`
  display: flex;
  padding: 20px 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  /* border-bottom: 1px solid #eee; */
`;

const BodyInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
`;

const BodyInfoHeader = styled.div`
  flex: 1 0 0;
  color: #333;

  /* Title/3/SemiBold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;

const BodyInfoBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const BodyInfoBodyContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const BodyInfoBottom = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 4px;
  align-self: stretch;
  flex-wrap: wrap;
`;

const BodyIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  ${props =>
    props.thumnail &&
    css`
      width: 80px !important;
      height: 80px !important;
      background-color: #f7f7fa;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
    `}
`;

const BodyIconContents = styled.div`
  display: flex;
  justify-content: center;
  width: 24px;
  height: 24px;

  ${props =>
    props.thumnail &&
    css`
      width: 41px !important;
      height: 53px !important;
    `}
`;

const Bottom = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-top: 1px solid #eee;
`;

const BottomButton = styled.div`
  height: 25px;
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 10px;

  ${(props) =>
    props.idx > 0 &&
    css`
      border-left: 1px solid #eee;
    `}
`;

const BottomButtonText = styled.span`
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: center;
  color: #666;
`;

export const TextDiv = styled.div`
  color: ${(props) => props.color};

  /* Body/3/Regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: ${(props) => props.fontWeight};
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.24px;
`;
export default ListCardInfo;
